// 席位上限（users_count_upper_limit）顯示規則。
//
// 後端語意：null＝不設席位上限。用於「無席位服務」（企業資料中心 17／自動化任務 18），
// 這類服務按企業年費計價，不做人數控管；後端 getMaximumNumberOfUsersUsingService
// 回 null 時會跳過人數檢查。
//
// 注意：不要用 `limit || 0` 之類的寫法，那會把 null 併進 0，畫面就變成「0 人」，
// 與「不限」的意思剛好相反。判斷只認 null（undefined 視為尚未取得，一律當 0）。
export const UNLIMITED_SEAT_LABEL = "不限";

/**
 * 席位上限顯示字串。
 * @param {number|null|undefined} limit 席位上限；null 代表不設上限
 * @param {number} extra 需一併加總的額外人數（加購／贈送），null 時忽略
 * @returns {string} 「不限」或「N 人」
 */
export const formatSeatLimit = (limit, extra = 0) =>
  limit === null
    ? UNLIMITED_SEAT_LABEL
    : `${(Number(limit) || 0) + (Number(extra) || 0)} 人`;
